// frontend/src/components/support/PackageGrid.js
import PackageCard from "./PackageCard";

export default function PackageGrid({ packages, onSelect }) {
  return (
    <div
      style={{
        display: "grid",

        gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",

        gap: 24,

        marginTop: 40,
      }}
    >
      {packages.map((pkg) => (
        <PackageCard key={pkg.id} pkg={pkg} onSelect={onSelect} />
      ))}
    </div>
  );
}
